<template>
  <div id="app" style="background-color: black;height: 100vh;">
    <img class="logo" src="AbbeyLogoWhiteOnTransaprent.png" />
    <p style="font-size:35px">The Unicorn has now<br>moved to<br><a style="color:white" href="https://theabbey.ac">https://theabbey.ac</a></p>
    <p style="font-size:35px;margin-top:30px;float: left; width: 80vw;margin-left: 10vw;">To visit our new site click <a style="color:white" href="https://theabbey.ac">here.</a></p>
  </div>
</template>

<script>

export default {
  name: 'app',

}
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
}  
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  img.logo {
    margin-top: 50px;
    max-width: 80vw;
  }
  p { color: white; font-weight: 600; }
}
</style>
